























































































































import Vue from 'vue';
import countTo from 'vue-count-to';
import AnswerlList from '@/components/AnswerlList.vue';
import StepContent from '@/components/StepContent.vue';

export default Vue.extend<any, any, any, any>({
	components: {
		AnswerlList, countTo, StepContent,
	},
	data: () => ({
		answer: undefined,
		secondStep: false,
		draggedOrgan: undefined,
		organOnScale: undefined, // True => organ has been dropped on SCALE
		isTableDropped: false, // True => organ has been dropped on TABLE
		segmentSourceId: 1, // The ID of segment from where we dragging out
		segments: [
			{
				lungs: true, liver: false, heart: false, kidneys: false, brain: false,
			},
			{
				lungs: false, liver: false, heart: false, kidneys: true, brain: false,
			},
			{
				lungs: false, liver: true, heart: false, kidneys: false, brain: false,
			},
			{
				lungs: false, liver: false, heart: true, kidneys: false, brain: false,
			},
			{
				lungs: false, liver: false, heart: false, kidneys: false, brain: true,
			},
		],
		weights: {
			liver: 1500,
			brain: 1336,
			lungs: 950,
			heart: 350,
			kidneys: 318,
		},
		unlock: false, // Unlocking on touchscreens
	}),
	computed: {
		weight() {
			return this.weights[this.organOnScale] ?? 0;
		},
		isOrderCorrect() {
			let isCorrect = true;
			Object.keys(this.weights).forEach((organ, index) => isCorrect = !isCorrect ? isCorrect : this.segments[index][organ] === true);
			return isCorrect;
		},
	},
	methods: {

		// Drag'n'drop on touch devices
		onTouchMove(event: TouchEvent) {
			if (!this.draggedOrgan) {
				return;
			}

			const { clientWidth, clientHeight } = this.$refs[this.draggedOrgan];
			this.$refs[this.draggedOrgan].style.zIndex = 100;
			this.$refs[this.draggedOrgan].style.top = `${event.touches[0].pageY - clientHeight / 2}px`;
			this.$refs[this.draggedOrgan].style.left = `${event.touches[0].pageX - clientWidth / 2}px`;
		},

		// Drag'n'drop on touch devices
		onTouchEnd(event: TouchEvent) {
			if (!this.draggedOrgan) {
				return;
			}

			const { pageX, pageY } = event.changedTouches[0];
			document.elementsFromPoint(pageX, pageY).forEach((element: Element) => {
				// Dropping on scale
				if (element === this.$refs.scale) {
					this.$refs[this.draggedOrgan].style.zIndex = -1;
					this.dropScaleHandler();
				}
				// Dropping on table
				else if (element.classList.contains('segments__segment')) {
					this.$refs[this.draggedOrgan].style.zIndex = -1;
					const segmentId = element.getAttribute('data-segment');
					this.dropTableHandler(undefined, segmentId);
				}
			});

			// If the drop is outside scale & table
			if (!this.isTableDropped && !this.organOnScale) {
				this.$refs[this.draggedOrgan].style.zIndex = -1;
				this.dragendOrganHandler(undefined, this.draggedOrgan, this.segmentSourceId);
			}
		},

		// Dragging from scale -> table
		dragstartScaleHandler(event: DragEvent, organ: string) {
			this.organOnScale = undefined;
			this.draggedOrgan = organ;

			const { clientWidth, clientHeight } = this.$refs[this.draggedOrgan];
			event?.dataTransfer?.setDragImage(this.$refs[this.draggedOrgan], clientWidth / 2, clientHeight / 2);
		},

		// Dragging from table -> scale
		dragstartTableHandler(event: DragEvent, organ: string, segmentId: number) {
			this.isTableDropped = false;
			this.draggedOrgan = organ;
			this.segmentSourceId = segmentId;
			this.segments[segmentId - 1][this.draggedOrgan] = false;

			const { clientWidth, clientHeight } = this.$refs[this.draggedOrgan];
			event?.dataTransfer?.setDragImage(this.$refs[this.draggedOrgan], clientWidth / 2, clientHeight / 2);
		},

		// Allow drop
		allowDrop(event: DragEvent) {
			event.preventDefault(); // Allow drag-drop
		},

		// Dragging organ from scale has ended
		dragendScaleHandler(event: DragEvent, organ: string) {
			if (!this.isTableDropped) {
				this.organOnScale = organ;
				this.draggedOrgan = undefined;
			}
		},

		dragendOrganHandler(event: DragEvent, organ: string, segmentId: number) {
			if (this.isTableDropped) {
				this.isTableDropped = false;
				this.draggedOrgan = undefined;
				return;
			}

			// If the organ hasn't been dropped on scale, return it back to the table.
			if (this.draggedOrgan && this.organOnScale !== this.draggedOrgan) {
				this.segments[segmentId - 1][this.draggedOrgan] = true;
				this.draggedOrgan = undefined;
			}
		},

		// Dropping onto scale
		dropScaleHandler(event: DragEvent) {
			if (this.organOnScale) {
				// If there's an organ on scale, return it to the table
				this.segments[this.segmentSourceId - 1][this.organOnScale] = true;
			}

			this.organOnScale = this.draggedOrgan;
			this.draggedOrgan = undefined;

			event.preventDefault();
		},

		// Dropping organs on tables
		dropTableHandler(event: DragEvent, segmentTargetId: number) {
			if (!this.draggedOrgan) {
				return;
			}

			// If there's an organ already, find empty spot and place the organ there
			const foundOrganId = Object.values(this.segments[segmentTargetId - 1]).indexOf(true);
			if (foundOrganId > -1) {
				// Get the rogan
				const foundOrgan = Object.keys(this.segments[segmentTargetId - 1])[foundOrganId];

				// Remove the organ from table
				this.segments[segmentTargetId - 1][foundOrgan] = false;

				// Place the dragged organ there instead
				this.segments[segmentTargetId - 1][this.draggedOrgan] = true;

				let beenFound = false;
				this.segments.forEach((segment: object, index: number) => {
					if (beenFound) {
						return;
					}

					//Find empty segment and place the organ there
					if (Object.values(segment).filter((isVisible: boolean) => isVisible).length === 0) {
						this.segments[index][foundOrgan] = true;
						beenFound = true;
					}
				});
			} else if (this.draggedOrgan) {
				this.segments[segmentTargetId - 1][this.draggedOrgan] = true;
			}

			this.isTableDropped = true;
			this.draggedOrgan = undefined;

			event.preventDefault();
		},
	},
});
